import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {Box, TextField} from "@common/components/";

/**
 * InputGroup - 輸入組合布局組件
 */
const InputGroup = ({ children, className, ...otherProps }) => {
    return (
        <Box
            className={clsx("input-group", className)}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

InputGroup.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

/**
 * StartAdornment - 左側裝飾區域組件
 */
const StartAdornment = ({ children, className = "", ...otherProps }) => {
    return (
        <Box
            className={clsx("start-adornment", className)}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

StartAdornment.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

/**
 * Input - 輸入框組件
 */
const Input = ({
    children,
    className = "",
    inputClassName = "",
    fullWidth = true,
    ...textFieldProps
}) => {
    // 如果外部提供了 children，使用外部組件（IoC）
    if (children) {
        return (
            <Box className={clsx("input-wrapper", className)}>
                {children}
            </Box>
        );
    }

    // 預設使用 TextField（向後兼容）
    return (
        <Box className={clsx("input-wrapper", className)}>
            <TextField
                className={clsx("input", inputClassName)}
                fullWidth={fullWidth}
                {...textFieldProps}
            />
        </Box>
    );
};

Input.propTypes = {
    children: PropTypes.node, // 外部提供的 input 組件（可選）
    className: PropTypes.string,
    inputClassName: PropTypes.string, // 僅在沒有 children 時使用
    fullWidth: PropTypes.bool, // 僅在沒有 children 時使用
};

/**
 * EndAdornment - 右側裝飾區域組件
 *
 * 用於放置按鈕、圖示等後置元素
 * 支援多個子元素，可用 Stack 或 Box 包裝多個按鈕
 */
const EndAdornment = ({ children, className = "", ...otherProps }) => {
    return (
        <Box
            className={clsx("end-adornment", className)}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

EndAdornment.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

// 將子組件附加到主組件，實現 Compound Components Pattern
InputGroup.StartAdornment = StartAdornment;
InputGroup.Input = Input;
InputGroup.EndAdornment = EndAdornment;

export default InputGroup;
